import React, { Component } from 'react';
import { RoundRow as Round, Row, ActionIconItem } from './style';
import { Text } from '../../../UI/Text';
import { Icon } from '../../../Components/Icons/Icons';

export class RoundRow extends Component {
    deleteRound = () => {
        const { index, actions } = this.props;
        actions.deleteRound(index);
    };

    duplicateRound = () => {
        const { index, actions } = this.props;
        actions.duplicateRound(index);
    };

    moveRoundUp = () => {
        const { index, actions } = this.props;
        actions.moveRoundUp(index);
    };

    moveRoundDown = () => {
        const { index, actions } = this.props;
        actions.moveRoundDown(index);
    };

    render() {
        const {
            props: { index },
            deleteRound,
            duplicateRound,
            moveRoundDown,
            moveRoundUp,
        } = this;

        return (
            <Round>
                <Heading>Round {index + 1}</Heading>
                <Row>
                    <ActionIconItem onClick={deleteRound}>
                        <Icon.Box size={'18x18'}>
                            <Icon.Delete />
                        </Icon.Box>
                    </ActionIconItem>
                    <ActionIconItem onClick={duplicateRound}>
                        <Icon.Box size={'18x18'}>
                            <Icon.Copy />
                        </Icon.Box>
                    </ActionIconItem>
                    <ActionIconItem onClick={moveRoundUp}>
                        <Icon.Box size={'18x18'}>
                            <Icon.ArrowUp />
                        </Icon.Box>
                    </ActionIconItem>
                    <ActionIconItem onClick={moveRoundDown}>
                        <Icon.Box size={'18x18'}>
                            <Icon.ArrowDown />
                        </Icon.Box>
                    </ActionIconItem>
                </Row>
            </Round>
        );
    }
}

const Heading = ({ children }) => (
    <Text uppercase={true} fontSize={12} weight={'bold'} marginTop={'5px'} opacity={0.5} marginLeft={'12px'}>
        {children}
    </Text>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/WorkoutPlan/RightBox/RoundRow.js